<template>
  <el-table-column
    prop="reference_number"
    label="Hivatkozási szám"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.reference_number || '-' }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'reference_number',
  };
</script>
